"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "role-timeline-header" };
const _hoisted_2 = { class: "role-timeline-header-content" };
const _hoisted_3 = { class: "role-timeline-header-grid" };
const vue_3 = require("vue");
const roleTimeLayout_1 = require("../roleTimeLayout");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleTimeFooter',
    props: {
        startHour: {},
        endHour: {}
    },
    setup(__props) {
        const props = __props;
        const hours = (0, vue_3.computed)(() => {
            const result = [];
            const duration = props.endHour - props.startHour;
            const step = 2 - (duration % 2);
            for (let hour = props.startHour; hour <= props.endHour; hour += step) {
                result.push(hour);
            }
            return result;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(hours.value, (hour) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: hour,
                                class: "role-timeline-header-label",
                                style: (0, vue_2.normalizeStyle)({
                                    left: `${(0, vue_2.unref)(roleTimeLayout_1.getRolePosition)(hour, props.startHour, props.endHour)}%`,
                                })
                            }, (0, vue_2.toDisplayString)(String(hour).padStart(2, "0")) + ":00 ", 5 /* TEXT, STYLE */));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]));
        };
    }
});
